export default __webpack_public_path__ + "static/media/main-slide-04.ddf18413.png";